<template>
  <CModal
    :title="title"
    color="info"
    :show="show"
    :centered="true"
    class="edit-roles-modal"
    @update:show="handleClose"
  >
    <div>
      <div class="modal-title">
        <h2 class="">{{ title }}</h2>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <div v-if="errors.length" class="my-3">
        <CAlert
          v-for="(error, index) in errors"
          :key="`error-${index}`"
          :show="90"
          color="danger"
          closeButton
        >
          {{ error }}
        </CAlert>
      </div>
    </div>

    <div>
      <h5 class="mt-3">Account Type</h5>
      <CRow class="my-3" v-if="organization && organization">
        <CCol sm="8">
          <CInputCheckbox
            label="Trial User"
            :checked.sync="organization.trialUser"
          ></CInputCheckbox>
        </CCol>
      </CRow>
      <CRow v-if="organization && organization && organization.trialUser">
        <CCol sm="8">
          <div width="100%">
            <datetime type="date" v-model="organization.trialExpiry">
              <label for="startDate" slot="before">Trial Expiry: </label>
              <span class="description" slot="after"
                ><br /><i>Expiry for trial account</i></span
              >
            </datetime>
          </div>
        </CCol>
      </CRow>
    </div>

    <template #footer>
      <CButton @click="handleCancel" color="secondary">Cancel</CButton>
      <CButton @click="handleSave" color="success">Save</CButton>
    </template>
  </CModal>
</template>

<script>
import { mapActions } from "vuex";
import getNested from "lodash-es/get";
import cloneDeep from "lodash-es/cloneDeep";
import { isEmpty } from "lodash-es";
import { DateTime } from "luxon";
import EditableField from "@/components/widgets/EditableField";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "edit-trial-modal",

  components: {
    EditableField,
    Datetime,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: "Trial parameters",
    },

    organization: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      errors: [],
      metadataInternal: null,
      organizationUpdatePending: false,
      loading: false,
    };
  },

  methods: {
    ...mapActions("users", ["updateTrial"]),

    handleCancel() {
      this.$emit("update:show", false);
    },

    async handleSave(evt) {
      if (evt) {
        evt.preventDefault();
      }

      this.loading = true;

      let org = this.organization;
      org.orgId = org.organizationId;
      org.appMetadata = {
        organization: org.orgId,
        trialExpiry: org.trialExpiry,
        trialUser: org.trialUser,
      };
      console.log(org);
      await this.updateTrial(org);

      if (!this.errors) {
        this.$emit("updated");
        this.$emit("update:show", false);
      }
      this.loading = false;
    },

    async updateTrialField(data) {
      this.metadataInternal = data;

      const sendData = {
        orgId: this.organizationId,
        appMetadata: this.metadataInternal,
      };
      // console.log('sendData', JSON.stringify(sendData, null, 2));

      const response = await this.updateTrial(sendData);
      if (response.error) {
        return response;
      } else {
        this.organizationUpdatePending = true;
        return getNested(response, "organization.appMetadata", {});
      }
    },

    handleUpdateError(data) {
      console.log("handleUpdateError", JSON.stringify(data, null, 2));
    },

    async handleClose(evt) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.organizationUpdatePending) {
        this.$emit("updated");
      }
      this.$emit("update:show", false);
    },
  },

  computed: {
    organizationId() {
      return getNested(this.organization, "organizationId", null);
    },

    dateFormats() {
      return {
        displayFormat: `y-LL-dd HH:mm:ss`,
        saveFormat: `y-LL-dd'T'HH:mm:ss'Z'`,
      };
    },
  },

  watch: {
    show(value) {
      if (!value) {
        // there is no need to update data in the hidden modal
        return;
      }

      this.errors = [];
      this.organizationUpdatePending = false;
      const originMetadata = getNested(this.organization, "appMetadata");
      if (isEmpty(originMetadata)) {
        // if no metadata is specified, default values are used
        const defaultDateTime = DateTime.local()
          .plus({ days: 14 })
          .toFormat(this.dateFormats.saveFormat);

        this.metadataInternal = {
          organization: this.organizationId,
          trialExpiry: defaultDateTime,
          trialHasExpired: false,
          trialUser: false,
        };
      } else {
        this.metadataInternal = cloneDeep(originMetadata);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.edit-roles-modal {
  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .fa-cog {
      color: #adadad;
    }
  }

  .details-row {
    // padding-bottom: 5px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted #d0d0d0;

    &__title {
      min-width: 100px;
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__value {
      padding-left: 10px;
      font-weight: 500;
      font-size: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
